<!-- 轮播图 -->
<template>
  <div class="banner">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" :key="i" v-for="(item,i) in banner" @click="linkPage(item)"><img style="width: 100%; height: 100%;" :src="item.url" /></div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>
      <!-- 如果需要导航按钮 -->
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
      <!-- 如果需要滚动条 -->
      <!-- <div class="swiper-scrollbar"></div> -->
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Banner',
    props:{
      banner:{
        type: Array,//传参类型
        default: [],//默认参数
      }
    },

    watch: {
        banner: {
            // handler: function(newVal, oldVal) {
                // this.bannerList = [...newVal ]
                // console.log(1,this.bannerList )
                // this.$nextTick(() => {
                   
                // });
            // // },
        }
    },
    data() {
      return {
        bannerList: [],
      };
    },
    mounted() {
      this.go()
      console.log(this.banner)
    },
    methods:{
      go(){
         var mySwiper = new this.Swiper('.swiper-container', {
            loop: true, // 循环模式选项
            effect: 'fade',
            type: 'bullets',
            autoplay: {delay: 2000,stopOnLastSlide: false},
            // 如果需要分页器
            pagination: { el: '.swiper-pagination'},
            // 如果需要前进后退按钮
            navigation: {nextEl: '.swiper-button-next',prevEl: '.swiper-button-prev'},
            // 如果需要滚动条
            scrollbar: {el: '.swiper-scrollbar'}
        });
      },
      //跳转到外部连接
      linkPage(url){
        if(url.includes('https://') || url.includes('http://') ){
        	window.location.href = url
        }else{
        	window.location.href = `https://${url}`
        }
      },
    },
  };
</script>

<style scoped>
  .swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after {
      content: '';
  }
  .swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after {
    content: '';
  }
  .swiper-button-next:after, .swiper-button-prev:after {
      text-transform: none!important;
      letter-spacing: 0;
      font-variant: initial;
      line-height: 1;
      font-size: 18px;
      color: #fff;
  }
  .swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    left: 6%;
    right: auto;
  }
  .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
    right: 6%;
    left: auto;
  }
  .swiper-button-next, .swiper-button-prev{
    position: absolute;
    top: 50%;
    width: 20px;
    height: 40px;
    margin-top: -20px;
    z-index: 10;
    cursor: pointer;
    text-align: right;
    color: #fff;
    background: url(../../static/image/ban_btn_1.png) no-repeat 0 0;
    -webkit-transition: all 0.3s ease-out 0s;
  }
  .swiper-button-next {
    text-align: left;
    background: url(../../static/image/ban_btn_2.png) no-repeat 0 0;
  }
  .swiper-pagination {
    position: absolute;
    text-align: center;
    transition: .3s opacity;
    transform: translate3d(0,0,0);
    z-index: 10;
  }
  .swiper-container-horizontal>.swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction {
    bottom: 30px;
    left: 0;
    width: 100% !important;
    cursor: pointer;
  }
  
</style>
<style>
  .swiper-pagination-bullet{
    width: 13px !important;
    height: 13px !important;
    border-radius: 13px;
    position: relative;
    background: #969696;
    display: inline-block;
    opacity: 1;
    transition: all 0.3s ease-out 0s;
    -webkit-transition: all 0.3s ease-out 0s;
    -moz-transition: all 0.3s ease-out 0s;
    -o-transition: all 0.3s ease-out 0s;
  }
  .swiper-pagination-bullet-active{
      background-color: #333 !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/Banner.vue